import { render, staticRenderFns } from "./EmdMundiLogo.vue?vue&type=template&id=53255b96"
import script from "./EmdMundiLogo.vue?vue&type=script&lang=js"
export * from "./EmdMundiLogo.vue?vue&type=script&lang=js"
import style0 from "./EmdMundiLogo.vue?vue&type=style&index=0&id=53255b96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports